module.exports = __webpack_public_path__ + "static/d956e4112461d0c817edc0dffb3abcfb081509dd665b7a3d0fc1b9ee27c97f14-35db2352c0cb57c23d1527b772ca29a7.png";